import { render, staticRenderFns } from "./DocRow.vue?vue&type=template&id=637e60b6"
import script from "./DocRow.vue?vue&type=script&lang=ts"
export * from "./DocRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports